import { render, staticRenderFns } from "./BasePaginate.vue?vue&type=template&id=238bdd6e&scoped=true"
import script from "./BasePaginate.vue?vue&type=script&lang=js"
export * from "./BasePaginate.vue?vue&type=script&lang=js"
import style0 from "./BasePaginate.vue?vue&type=style&index=0&id=238bdd6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238bdd6e",
  null
  
)

export default component.exports